<template>
  <div :class="rootClass">
    <img class="ad-more-options__icon" :src="adIconSrc" alt="" />
    <h3 class="ad-more-options__title">
      {{ $t("lbl_EMPBE_MoreAdvertisingOptions_Headline") }}
    </h3>
    <p class="ad-more-options__desc">
      {{ $t("lbl_EMPBE_MoreAdvertisingOptions_Subtext") }}
    </p>
    <div class="ad-more-options__actions">
      <b-button
        v-if="learnMoreUrl"
        class="ad-more-options__btn ad-more-options__btn--learn"
        variant="light"
        @click="goLearnMoreUrl"
        v-bind:t_label="'EMPBE_MoreAdvertisingOptions_ViewDetails'"
      >
        <span>{{ $t("lbl_EMPBE_MoreAdvertisingOptions_ViewDetails") }}</span>
      </b-button>
      <b-button
        class="ad-more-options__btn ad-more-options__btn--sales"
        variant="primary"
        @click="onContactSales"
        v-bind:t_label="'EMPBE_MoreAdvertisingOptions_ContactSales'"
      >
        <img :src="cellIconSrc" alt="" />
        <span>{{ $t("lbl_EMPBE_MoreAdvertisingOptions_ContactSales") }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoreAdvertisingOptions",
  props: {
    cdnURL: {
      type: String,
      required: true,
    },
    langid: {
      type: String,
      default: "1252",
    },
    cellUrl: {
      type: String,
      default: "",
    },
    learnMoreUrl: {
      type: String,
      default: "",
    },
    /** page = 空状态整页；panel = 锚定在 Explore More Ads 下的浮层卡片 */
    variant: {
      type: String,
      default: "page",
      validator: (v) => ["page", "modal", "panel"].includes(v),
    },
  },
  computed: {
    rootClass() {
      const isPanel = this.variant === "modal" || this.variant === "panel";
      return [
        "ad-more-options",
        isPanel ? "ad-more-options--panel" : "ad-more-options--page",
      ];
    },
    adIconSrc() {
      return `${this.cdnURL}svg/AdvertisingInfoCenter/MoreAd_${this.langid}.svg`;
    },
    cellIconSrc() {
      return `${this.cdnURL}svg/componentsIcon/cell.svg`;
    },
  },
  methods: {
    goLearnMoreUrl() {
      if (this.learnMoreUrl) {
        window.open(this.learnMoreUrl, "_blank");
      }
    },
    onContactSales() {
      this.$emit("contact-sales");
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-more-options {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: #fff;
}

.ad-more-options--page {
  min-height: 360px;
  border: 1px solid #ececf2;
  border-radius: 16px;
  gap: 16px;
  padding: 100px 0;
}

.ad-more-options--panel {
  width: 100%;
  max-width: 480px;
  gap: 24px;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 15px rgba(183, 183, 183, 0.3);
}

.ad-more-options__icon {
  width: 150px;
  height: 100px;
  object-fit: contain;
}

.ad-more-options--page .ad-more-options__icon {
  width: 300px;
  height: 200px;
}

.ad-more-options__title {
  margin: 0;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.8);
}

.ad-more-options--page .ad-more-options__title {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.86);
}

.ad-more-options__desc {
  margin: 0;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.5);
}

.ad-more-options--page .ad-more-options__desc {
  max-width: 620px;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.56);
}

.ad-more-options__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.ad-more-options__btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center;
  gap: 8px !important;
  min-height: 40px !important;
  height: 40px !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
}

.ad-more-options__btn--learn {
  background: #fff !important;
  color: rgba(0, 0, 0, 0.6) !important;
  border: 1px solid rgba(0, 0, 0, 0.6) !important;
}

.ad-more-options__btn--learn:hover,
.ad-more-options__btn--learn:focus,
.ad-more-options__btn--learn:active {
  background: rgba(0, 0, 0, 0.03) !important;
  color: rgba(0, 0, 0, 0.8) !important;
  border-color: rgba(0, 0, 0, 0.6) !important;
  box-shadow: none !important;
}

.ad-more-options__btn--sales {
  background: #7366ff !important;
  color: #fff !important;
  border: none !important;
  padding-left: 8px !important;
  padding-right: 16px !important;
}

.ad-more-options__btn--sales:hover,
.ad-more-options__btn--sales:focus,
.ad-more-options__btn--sales:active {
  background: #6356e8 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.ad-more-options__btn--sales img {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
</style>
